import { api } from '../api';

/** Recién nacido detectado en Binary pendiente de completar (VEN-513). */
export interface RecienNacidoPendiente {
  asociadoId: string;
  legajo: string;
  empresaId: string;
  apellSolt: string;
  nombres: string;
  fechaNacimiento: string;
  sexo: string;
  tipoDoc: string;
  documento: string;
  cuil: string;
  parentesco: string;
  estadoCivil: string;
  email: string;
  areaCelular: string;
  numeroCelular: string;
  nacionalidad: string;
  domicilio: string;
  numero: string;
  piso: string;
  depto: string;
  cp: string;
  binaryAfiId: string;
  titular: { apellSolt: string; nombres: string; documento: string } | null;
  /** Qué faltaba al detectarlo: `documento`, `nombres`, `sexo`. */
  camposFaltantes: string[];
  detectadoAt: string;
  duplicadoAfiIds: string[];
}

/**
 * Lo que la organización completa. Apellido, nombres, sexo, fecha, documento,
 * CUIL, estado civil, email y celular viajan a Binary; nacionalidad, domicilio
 * y CP quedan solo en el portal (Binary no los acepta por este circuito).
 */
export interface CompletarRecienNacidoPayload {
  apellSolt?: string;
  nombres?: string;
  sexo?: string;
  fechaNacimiento?: string;
  tipoDoc?: string;
  documento?: string;
  cuil?: string;
  estadoCivil?: string;
  email?: string;
  areaCelular?: string;
  numeroCelular?: string;
  nacionalidad?: string;
  domicilio?: string;
  numero?: string;
  piso?: string;
  depto?: string;
  cp?: string;
}

export interface CompletarRecienNacidoResp {
  /** null si solo cambiaron datos del portal (no hubo trámite a Binary). */
  loteId: string | null;
  novedades: number;
  /** Campos que quedaron solo en el portal. */
  soloPortal: string[];
  asociadoId: string;
}

export async function listRecienNacidos(): Promise<RecienNacidoPendiente[]> {
  const { data } = await api.get<RecienNacidoPendiente[]>('/recien-nacidos');
  return data;
}

/**
 * Completa los datos: el backend arma y despacha un trámite de Modificación de
 * datos identificado por AFI_ID (Binary actualiza a la persona que ya tiene).
 * El trámite se sigue después en Modificación de datos.
 */
export async function completarRecienNacido(
  asociadoId: string,
  payload: CompletarRecienNacidoPayload,
): Promise<CompletarRecienNacidoResp> {
  const { data } = await api.post<CompletarRecienNacidoResp>(
    `/recien-nacidos/${asociadoId}/completar`,
    payload,
  );
  return data;
}
